import store from '@state/store'

export default [
  // --------------- GUEST ROUTES ----------------
  {
    path: '/',
    name: 'home',
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        next({
          name: 'safehaven-dashboard',
          params: {
            clientId: routeTo.params.clientId
              ? routeTo.params.clientId
              : 'healthbook',
          },
        })
      },
    },
  },
  {
    path: '/:clientId/dashboard',
    name: 'safehaven-home',
    redirect: { name: 'safehaven-dashboard' },
  },
  {
    path: '/login',
    name: 'login',
    redirect: {
      name: 'safehaven-dashboard',
      params: { clientId: 'healthbook' },
    },
  },
  {
    path: '/:clientId/verify',
    name: 'verify',
    component: require('@src/router/views/auth/login/verify.vue').default,
    props: true,
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (
          store.getters['auth/loggedIn'] &&
          store.getters['auth/limitedAccess'] &&
          store.getters['auth/hasMfa']
        ) {
          // Continue to verify page
          next()
        } else {
          // Redirect to the not found page instead
          next({
            name: '404',
            params: {
              clientId: routeTo.params.clientId
                ? routeTo.params.clientId
                : 'healthbook',
            },
          })
        }
      },
    },
  },
  {
    path: '/register',
    name: 'register',
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        next({
          name: 'safehaven-access-code',
          params: {
            clientId: routeTo.params.clientId
              ? routeTo.params.clientId
              : 'healthbook',
          },
        })
      },
    },
  },
  {
    path: '/email/confirm/:uid/:token',
    name: 'email.confirm',
    component: () => lazyLoadView(import('@views/email/confirm.vue')),
  },
  {
    path: '/password/reset/:uid?/:token?',
    name: 'password.reset',
    component: () =>
      lazyLoadView(import('@views/auth/login/reset-password.vue')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the dashboard page instead
          next({ name: 'dashboard' })
        } else {
          // Continue to the password reset page
          next()
        }
      },
    },
  },
  {
    path: '/code-retrieval',
    name: 'code-retrieval',
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        next({
          name: 'safehaven-code-retrieval',
          params: {
            clientId: routeTo.params.clientId
              ? routeTo.params.clientId
              : 'healthbook',
          },
        })
      },
    },
  },
  {
    path: '/register/success',
    name: 'registration-success',
    component: require('@src/router/views/auth/registration/success.vue')
      .default,
  },
  // ---------- SAFEHAVEN ROUTES START-------------
  {
    path: '/:clientId/login',
    name: 'safehaven-login',
    component: () => lazyLoadView(import('@views/safehaven/login/signin.vue')),
    props: true,
    meta: {
      showLogo: true,
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (
          store.getters['auth/loggedIn'] &&
          store.getters['auth/fullAccess']
        ) {
          // Redirect to the dashboard page instead
          next({
            name: 'safehaven-dashboard',
            params: { clientId: routeTo.params.clientId },
          })
          // If the user is limited
        } else if (
          store.getters['auth/loggedIn'] &&
          store.getters['auth/limitedAccess']
        ) {
          // Redirect to the verify page instead
          next({
            name: 'verify',
            params: { clientId: routeTo.params.clientId },
          })
        } else {
          // Continue to the home page
          next()
        }
      },
    },
  },
  {
    path: '/:clientId/dashboard',
    name: 'safehaven-dashboard',
    props: true,
    component: () =>
      lazyLoadView(import('@views/safehaven/dashboard/index.vue')),
    meta: {
      authRequired: false,
      breadCrumb: 'Dashboard',
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        store.getters['auth/loggedIn'] && store.getters['auth/fullAccess']
          ? // Continue to settings page
            next()
          : // Redirect to the not found page instead
            next({
              name: 'safehaven-login',
              params: { clientId: routeTo.params.clientId },
            })
      },
    },
  },
  {
    path: '/:clientId/dashboard',
    name: 'dashboard',
    props: true,
    component: () =>
      lazyLoadView(import('@views/safehaven/dashboard/index.vue')),
    meta: {
      authRequired: false,
      breadCrumb: 'Dashboard',
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        store.getters['auth/loggedIn'] && store.getters['auth/fullAccess']
          ? // Continue to settings page
            next()
          : // Redirect to the not found page instead
            next({
              name: 'safehaven-login',
              params: { clientId: routeTo.params.clientId },
            })
      },
    },
  },
  {
    path: '/:clientId/signup',
    name: 'safehaven-signup',
    props: true,
    component: require('@views/safehaven/sign-up/signup.vue').default,
    meta: {
      showLogo: true,
      signup: true,
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the dashboard page instead
          next({
            name: 'safehaven-dashboard',
            params: { clientId: routeTo.params.clientId },
          })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/:clientId/code-retrieval',
    name: 'safehaven-code-retrieval',
    component: require('@views/safehaven/sign-up/code-retrieval.vue').default,
    meta: {
      showLogo: true,
      codeRetrieval: true,
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the dashboard page instead
          next({
            name: 'safehaven-dashboard',
            params: { clientId: routeTo.params.clientId },
          })
        } else {
          // Continue to the password reset page
          next()
        }
      },
    },
  },
  {
    path: '/:clientId/access-code',
    name: 'safehaven-access-code',
    component: require('@views/safehaven/sign-up/access-code.vue').default,
    meta: {
      showLogo: true,
      accessCode: true,
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the dashboard page instead
          next({
            name: 'safehaven-dashboard',
            params: { clientId: routeTo.params.clientId },
          })
        } else {
          // Continue to the password reset page
          next()
        }
      },
    },
  },
  {
    path: '/:clientId/forgotpassword',
    name: 'safehaven-forgotpassword',
    component: require('@views/safehaven/forgot-password/forgot-password.vue')
      .default,
    meta: {
      showLogo: true,
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the dashboard page instead
          next({
            name: 'safehaven-dashboard',
            params: { clientId: routeTo.params.clientId },
          })
        } else {
          // Continue to the password reset page
          next()
        }
      },
    },
  },
  {
    path: '/:clientId/password/reset/:uid?/:token?',
    name: 'safehaven-reset-password',
    component: () =>
      lazyLoadView(
        import('@views/safehaven/forgot-password/reset-password.vue')
      ),
    meta: {
      showLogo: true,
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the dashboard page instead
          next({
            name: 'safehaven-dashboard',
            params: { clientId: routeTo.params.clientId },
          })
        } else {
          // Continue to the password reset page
          next()
        }
      },
    },
  },
  {
    path: '/:clientId/health-record/recipient-verification',
    name: 'recipient-verification',
    component: () =>
      lazyLoadView(
        import(
          '@views/safehaven/health-record/sharing/recipient-verification.vue'
        )
      ),
    meta: {
      layout: () => lazyLoadView(import('@layouts/safehaven-guest.vue')),
      authRequired: false,
      independent: true,
    },
  },
  {
    path: '/:clientId/health-vault/health-vault-recipient-verification',
    name: 'health-vault-recipient-verification',
    component: () =>
      lazyLoadView(
        import(
          '@views/safehaven/health-vault/sharing/health-vault-recipient-verification.vue'
        )
      ),
    meta: {
      layout: () => lazyLoadView(import('@layouts/safehaven-guest.vue')),

      authRequired: false,
      independent: true,
    },
  },
  {
    path: '/:clientId/welcome',
    name: 'safehaven-welcome',
    component: () =>
      lazyLoadView(import('@views/safehaven/welcome/welcome.vue')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser.user || {} }),
  },
  {
    path: '/:clientId/healthhelp',
    name: 'safehaven-health-help',
    component: () =>
      lazyLoadView(import('@views/safehaven/health-help/health-help.vue')),
    meta: {
      authRequired: true,
      breadCrumb: 'Health Help',
    },
  },
  {
    path: '/:clientId/symptom-checker',
    name: 'safehaven-symptom-checker',
    component: () =>
      lazyLoadView(
        import(
          '@views/safehaven/health-help/symptom-checker/symptom-checker.vue'
        )
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Symptom Checker',
    },
  },
  {
    path: '/:clientId/isabel-symptom-checker',
    name: 'isabel-symptom-checker',
    component: () =>
      lazyLoadView(
        import(
          '@views/safehaven/isabel-symptom-checker/isabel-symptom-checker.vue'
        )
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Symptom Checker',
    },
  },
  {
    path: '/:clientId/health-check',
    name: 'health-check',
    component: () =>
      lazyLoadView(
        import(
          '@views/safehaven/health-help/symptom-checker/symptom-checker.vue'
        )
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Symptom Checker',
    },
  },
  {
    path: '/:clientId/peer-coaching',
    name: 'safehaven-peer-coaching',
    component: () =>
      lazyLoadView(
        import('@views/safehaven/health-help/peer-coaching/peer-coaching.vue')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Peer Coaching',
    },
  },
  {
    path: '/:clientId/peer-coaching',
    name: 'peer-coaching',
    component: () =>
      lazyLoadView(
        import('@views/safehaven/health-help/peer-coaching/peer-coaching.vue')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Peer Coaching',
    },
  },
  {
    path: '/:clientId/health-help/peer-coaching/chat-in-progress',
    name: 'chat-in-progress',
    component: () =>
      lazyLoadView(import('@views/safehaven/chat/chat-in-progress.vue')),
    meta: {
      authRequired: true,
      breadCrumb: 'Peer Coaching',
    },
  },
  {
    path: '/:clientId/health-help/telehealth',
    name: 'safehaven-telehealth',
    component: () =>
      lazyLoadView(
        import('@views/safehaven/health-help/telehealth/telehealth.vue')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Telehealth',
    },
  },
  {
    path: '/:clientId/health-help/telehealth',
    name: 'telehealth',
    component: () =>
      lazyLoadView(
        import('@views/safehaven/health-help/telehealth/telehealth.vue')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Telehealth',
    },
  },

  {
    path: '/:clientId/health-record',
    name: 'safehaven-health-record',
    component: () =>
      lazyLoadView(import('@views/safehaven/health-record/health-record.vue')),
    meta: {
      authRequired: true,
      breadCrumb: 'Health record',
    },
  },
  {
    path: '/:clientId/health-record',
    name: 'health-record',
    component: () =>
      lazyLoadView(import('@views/safehaven/health-record/health-record.vue')),
    meta: {
      authRequired: true,
      breadCrumb: 'Health record',
    },
  },
  {
    path: '/:clientId/health-vault',
    name: 'safehaven-health-vault',
    component: () =>
      lazyLoadView(import('@views/safehaven/health-vault/health-vault.vue')),
    meta: {
      authRequired: true,
      breadCrumb: 'Document Center',
    },
  },
  {
    path: '/:clientId/health-vault',
    name: 'health-vault',
    component: () =>
      lazyLoadView(import('@views/safehaven/health-vault/health-vault.vue')),
    meta: {
      authRequired: true,
      breadCrumb: 'Document Center',
    },
  },
  {
    path: '/:clientId/share-record-link-revoked',
    name: 'share-record-link-revoked',
    component: () =>
      lazyLoadView(
        import('@components/dialogs/safehaven/share-record-link-revoked.vue')
      ),
    meta: {
      layout: () => lazyLoadView(import('@layouts/safehaven-guest.vue')),
      navBar: true,
      authRequired: false,
      breadCrumb: 'share-record-link-revoked',
    },
  },
  {
    path: '/:clientId/share-health-record-link-revoked',
    name: 'share-health-record-link-revoked',
    component: () =>
      lazyLoadView(
        import(
          '@components/dialogs/safehaven/share-health-record-link-revoked.vue'
        )
      ),
    meta: {
      layout: () => lazyLoadView(import('@layouts/safehaven-guest.vue')),
      navBar: true,
      authRequired: false,
      breadCrumb: 'share-health-record-link-revoked',
    },
  },
  {
    path: '/:clientId/sharedrecord',
    name: 'shared-record-view',
    component: () =>
      lazyLoadView(
        import('@views/safehaven/share-record-view/share-record-view.vue')
      ),
    meta: {
      layout: () => lazyLoadView(import('@layouts/safehaven-guest.vue')),
      breadCrumb: 'Shared Health record',
    },
  },
  {
    path: '/:clientId/health-help/telehealth/provider-list',
    name: 'safehaven-provider-list',
    component: () =>
      lazyLoadView(
        import(
          '@views/safehaven/health-help/telehealth/provider-list/provider-list.vue'
        )
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Provider List',
    },
  },
  {
    path: '/:clientId/health-help/telehealth/provider-details',
    name: 'safehaven-provider-details',
    component: () =>
      lazyLoadView(
        import('@views/safehaven/health-help/telehealth/provider-details.vue')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Telehealth',
    },
  },
  {
    path: '/:clientId/health-help/telehealth/appointment-scheduled',
    name: 'safehaven-appointment-scheduled',
    component: () =>
      lazyLoadView(
        import(
          '@views/safehaven/health-help/telehealth/appointment-scheduled/appointment-scheduled.vue'
        )
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Appointment Scheduled',
    },
  },
  {
    path: '/:clientId/profile-questionnaire',
    name: 'profile-questionnaire',
    component: () =>
      lazyLoadView(
        import(
          '@views/safehaven/profile-questionnaire/profile-questionnaire.vue'
        )
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Profile Questionnaire',
    },
    props: (route) => ({ user: store.state.auth.currentUser.user || {} }),
  },
  {
    path: '/:clientId/profile-questionnaire/thank-you',
    name: 'thank-you',
    component: () =>
      lazyLoadView(
        import('@views/safehaven/profile-questionnaire/thank-you/thankyou.vue')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Thank You',
    },
  },
  {
    path: '/:clientId/generic-dashboard',
    name: 'safehaven-generic-dashboard',
    component: () =>
      lazyLoadView(
        import('@views/safehaven/generic-dashboard/generic-dashboard.vue')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Dashboard',
    },
  },
  {
    path: '/:clientId/safeHavenLogout',
    name: 'safeHavenLogout',
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        await store.dispatch('auth/logOut')
        // Navigate back to previous page, or home as a fallback
        window.location.href = `/${routeTo.params.clientId}/login`
      },
    },
  },
  {
    path: '/:clientId/email/confirm/:uid/:token',
    name: 'safeHaven-email-confirm',
    component: () => lazyLoadView(import('@views/safehaven/email/confirm.vue')),
  },
  {
    path: '/:clientId/settings/profile',
    name: 'safehaven-profile',
    component: () =>
      lazyLoadView(import('@/src/router/views/safehaven/settings/profile.vue')),
    meta: {
      authRequired: true,
      description: 'safehaven-profile',
      breadCrumb: 'safehaven-profile',
    },
  },
  {
    path: '/:clientId/careclub',
    name: 'safehaven-careclub',
    component: () =>
      lazyLoadView(import('@/src/router/views/safehaven/careclub/index.vue')),
    meta: {
      authRequired: true,
      description: 'connection-hub',
      breadCrumb: 'connection-hub',
    },
  },
  {
    path: '/:clientId/connection-hub',
    name: 'connection-hub',
    component: () =>
      lazyLoadView(
        import('@/src/router/views/safehaven/connection-hub/index.vue')
      ),
    meta: {
      authRequired: true,
      description: 'connection-hub',
      breadCrumb: 'connection-hub',
    },
  },
  {
    path: '/:clientId/health-help/telehealth/confirm-appointment',
    name: 'confirm-appointment',
    component: () =>
      lazyLoadView(
        import(
          '@views/safehaven/health-help/telehealth/confirm-appointment.vue'
        )
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'telehealth',
    },
  },
  {
    path: '/:clientId/calendar',
    name: 'safehaven-calendar',
    component: () =>
      lazyLoadView(import('@views/safehaven/calendar/calendar.vue')),
    meta: {
      authRequired: true,
      breadCrumb: 'calendar',
    },
  },
  {
    path: '/:clientId/calendar',
    name: 'calendar',
    component: () =>
      lazyLoadView(import('@views/safehaven/calendar/calendar.vue')),
    meta: {
      authRequired: true,
      breadCrumb: 'calendar',
    },
  },
  {
    path: '/:clientId/health-help/telehealth/event-details',
    name: 'event-details',
    component: () =>
      lazyLoadView(
        import('@views/safehaven/health-help/telehealth/event-details.vue')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'telehealth',
    },
  },
  {
    path: '/:clientId/health-help/telehealth/cancel-confirmation',
    name: 'cancel-confirmation',
    component: () =>
      lazyLoadView(
        import(
          '@views/safehaven/health-help/telehealth/cancel-confirmation.vue'
        )
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'telehealth',
    },
  },
  {
    path: '/:clientId/chat/end-secure-chat-screen',
    name: 'end-secure-chat-screen',
    component: () =>
      lazyLoadView(import('@views/safehaven/chat/end-secure-chat-screen.vue')),
    meta: {
      authRequired: true,
      breadCrumb: 'end-secure-chat-screen',
    },
  },
  {
    path: '/:clientId/profile-success',
    name: 'profile-success',
    component: () =>
      lazyLoadView(import('@views/safehaven/profile/profile-success.vue')),
    meta: {
      authRequired: true,
      breadCrumb: 'profile-success',
    },
  },
  {
    path: '/:clientId/caring-person-info',
    name: 'caring-person-info',
    component: () =>
      lazyLoadView(
        import('@components/safehaven/care-club/caring-circle-info.vue')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'caring-person-info',
    },
  },
  {
    path: '/:clientId/shared-documents',
    name: 'shared-documents',
    component: () =>
      lazyLoadView(import('@views/health-record/shared-document-list.vue')),

    meta: {
      layout: () => lazyLoadView(import('@layouts/safehaven-guest.vue')),
      authRequired: false,
      breadCrumb: 'caring-person-info',
    },
  },
  {
    path: '/:clientId/share-record-link-expired',
    name: 'share-record-link-expired',
    component: () =>
      lazyLoadView(
        import('@components/dialogs/safehaven/share-record-link-expired.vue')
      ),
    meta: {
      layout: () => lazyLoadView(import('@layouts/safehaven-guest.vue')),
      navBar: false,
      authRequired: false,
      breadCrumb: 'share-record-link-expired',
    },
  },

  {
    path: '/:clientId/sharedrecords/:uid/:token',
    name: 'sharedrecords',
    component: () =>
      lazyLoadView(
        import('@components/safehaven/health-record-confirn-loader.vue')
      ),
    meta: {
      layout: () => lazyLoadView(import('@layouts/safehaven-guest.vue')),
      navBar: false,
      authRequired: false,
      breadCrumb: 'share-record-link-expired',
    },
  },
  {
    path: '/:clientId/shareddocs/:uid/:token',
    name: 'receiveddocuments',
    component: () =>
      lazyLoadView(
        import('@components/safehaven/share/health-vault-confirm-loader.vue')
      ),
    meta: {
      layout: () => lazyLoadView(import('@layouts/safehaven-guest.vue')),
      navBar: false,
      authRequired: false,
      breadCrumb: 'share-record-link-expired',
    },
  },
  {
    path: '/:clientId/mental-health-survey/general',
    name: 'mental-health-survey',
    component: () =>
      lazyLoadView(
        import('@views/safehaven/mental-health-survey/mental-health-survey.vue')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'mental-health-survey',
    },
  },
  {
    path: '/:clientId/mental-health-survey/profile-questionnaire',
    name: 'mental-health-survey-profile-questionnaire',
    component: () =>
      lazyLoadView(
        import('@views/safehaven/mental-health-survey/mental-health-survey.vue')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'mental-health-survey',
    },
  },
  {
    path: '/:clientId/mental-health-survey/profile-questionnaire',
    name: 'quetionnaire',
    component: () =>
      lazyLoadView(
        import('@views/safehaven/mental-health-survey/mental-health-survey.vue')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'mental-health-survey',
    },
  },
  {
    path: '/:clientId/mental-health-survey/phq-2',
    name: 'mental-health-survey-phq2',
    component: () =>
      lazyLoadView(
        import('@views/safehaven/mental-health-survey/mental-health-survey.vue')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'mental-health-survey',
    },
  },
  {
    path: '/:clientId/mental-health-survey/phq-7',
    name: 'mental-health-survey-phq7',
    component: () =>
      lazyLoadView(
        import('@views/safehaven/mental-health-survey/mental-health-survey.vue')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'mental-health-survey',
    },
  },
  {
    path: '/:clientId/mental-health-survey/phq-9',
    name: 'mental-health-survey-phq9',
    component: () =>
      lazyLoadView(
        import('@views/safehaven/mental-health-survey/mental-health-survey.vue')
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'mental-health-survey',
    },
  },

  {
    path: '/:clientId/health-action/result',
    name: 'health-action-result',
    props: true,
    component: () =>
      lazyLoadView(
        import('@components/mental-health-survey/health-action-result.vue')
      ),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (routeTo.params.action) {
          next()
        } else {
          next({
            name: 'mental-health-survey-profile-questionnaire',
            params: { clientId: routeTo.params.clientId },
          })
        }
      },
    },
  },
  {
    path: '/:clientId/health-help',
    name: 'health-help',
    component: () =>
      lazyLoadView(import('@views/safehaven/health-help/health-help.vue')),
    meta: {
      authRequired: true,
      breadCrumb: 'Health Help',
    },
  },
  {
    path: '/:clientId/operations',
    name: 'admin-operations',
    component: () =>
      lazyLoadView(
        import(
          '@views/safehaven/operational-dashboard/operational-dashboard.vue'
        )
      ),
    meta: {
      authRequired: true,
      breadCrumb: 'Operational Dashboard',
    },
  },
  {
    path: '/:clientId/sharedqrcoderecords/:uid/:token',
    name: 'sharedqrcoderecords',
    component: () =>
      lazyLoadView(
        import('@components/safehaven/health-record-qr-confirm-loader.vue')
      ),
    meta: {
      layout: () => lazyLoadView(import('@layouts/safehaven-guest.vue')),
      navBar: false,
      authRequired: false,
      breadCrumb: 'share-record-link-qr-code',
    },
  },
  {
    path: '/:clientId/health-record/recipient-qr-code-verification',
    name: 'recipient-qr-code-verification',
    component: () =>
      lazyLoadView(
        import(
          '@views/safehaven/health-record/sharing/recipient-qr-verification.vue'
        )
      ),
    meta: {
      layout: () => lazyLoadView(import('@layouts/safehaven-guest.vue')),
      authRequired: false,
      independent: true,
    },
  },
  // ---------- SAFEHAVEN ROUTES END-------------

  // ----------- ADMIN ROUTES STARTS -------
  {
    path: '/:clientId/addUser/home',
    name: 'admin-home',
    props: true,
    component: () => lazyLoadView(import('@views/admin/home/admin-home.vue')),
  },

  // --------- ADMIN ROUTES END -------
  // ---------- SECURE ROUTES ------------
  {
    path: '/:clientId/2fa/register',
    name: '2fa.register',
    component: require('@components/safehaven-account/mfa/register.vue')
      .default,
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (
          store.getters['auth/loggedIn'] &&
          store.getters['auth/fullAccess'] &&
          !store.getters['auth/hasMfa']
        ) {
          // Continue to 2fa register page
          next()
        } else {
          // Redirect to the 404 page instead
          next({
            name: '404',
            params: {
              clientId: routeTo.params.clientId
                ? routeTo.params.clientId
                : 'healthbook',
            },
          })
        }
      },
    },
  },
  {
    path: '/:clientId/2fa/qrgoogle',
    name: '2fa.qrgoogle',
    component: require('@components/safehaven-account/mfa/qrgoogle.vue')
      .default,
    props: true,
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (
          store.getters['auth/loggedIn'] &&
          store.getters['auth/fullAccess'] &&
          store.getters['auth/hasMfa'] &&
          store.getters['auth/isMfaGoogle']
        ) {
          // Continue to 2fa google page
          next()
        } else {
          // Redirect to the 404 page instead
          next({
            name: '404',
            params: {
              clientId: routeTo.params.clientId
                ? routeTo.params.clientId
                : 'healthbook',
            },
          })
        }
      },
    },
  },
  {
    path: '/:clientId/about',
    name: 'healthbookplus-about',
    component: () => lazyLoadView(import('@views/_about.vue')),
  },
  {
    path: '/:clientId/privacy',
    name: 'healthbookplus-privacy',
    component: () => lazyLoadView(import('@views/_privacy.vue')),
  },
  {
    path: '/:clientId/terms',
    name: 'healthbookplus-terms',
    component: () => lazyLoadView(import('@views/terms.vue')),
  },
  {
    path: '/:clientId/journal',
    name: 'journal',
    component: () => lazyLoadView(import('@views/journal.vue')),
  },
  {
    path: '/:clientId/insurance',
    name: 'insurance',
    component: () => lazyLoadView(import('@views/insurance.vue')),
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      async beforeResolve(routeTo, routeFrom, next) {
        await store.dispatch('auth/logOut')
        // Navigate back to previous page, or home as a fallback
        window.location.href = '/'
      },
    },
  },

  // EMAIL CONFIRMATION
  {
    path: '/:clientId/email-confirmation',
    name: 'email-confirmation',
    component: () =>
      lazyLoadView(import('@views/safehaven/sign-up/email-confirmation.vue')),
    meta: {
      showLogo: true,
    },
  },
  // PHONE NUMBER CONFIRMATION
  {
    path: '/:clientId/phone-number-confirmation',
    name: 'phone-number-confirmation',
    component: () =>
      lazyLoadView(
        import('@views/safehaven/sign-up/phone-number-confirmation.vue')
      ),
    meta: {
      showLogo: true,
    },
  },
  {
    path: '/:clientId/resend-promo-code',
    name: 'resend-promo-code',
    component: () =>
      lazyLoadView(import('@views/safehaven/sign-up/resend-promo-code.vue')),
  },
  {
    path: '/:clientId/404',
    name: '404',
    props: true,
    component: () => lazyLoadView(import('@views/_404.vue')),
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        next({
          name: '404',
          params: {
            clientId: routeTo.params.pathMatch.split('/')[1],
          },
        })
      },
    },
  },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/_loading.vue').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout.vue').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
